import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface ProgressBarProps {
  progress: number;
  variant?: "primary" | "success" | "warning";
  size?: "sm" | "md";
  className?: string;
}

export function ProgressBar({ progress, variant = "primary", size = "sm", className }: ProgressBarProps) {
  const colors = {
    primary: "bg-primary",
    success: "bg-success",
    warning: "bg-warning",
  };

  return (
    <div className={cn("w-full bg-secondary rounded-full overflow-hidden", size === "sm" ? "h-2" : "h-3", className)}>
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 1, ease: [0.25, 0.1, 0.25, 1] }}
        className={cn("h-full rounded-full", colors[variant])}
      />
    </div>
  );
}
